export default {
  title: 'Ordrelayout',
  form: {
    show_hero_image_with_offers: {
      label: 'Vis heltebillede sammen med tilbud',
      description: 'Når du tilføjer et tilbudsbillede, skjules heltebilledet som standard. Aktivér for at vise begge.',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
